import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { XpoGridBar } from './grid-bar.component';

@NgModule({
  imports: [CommonModule],
  declarations: [XpoGridBar],
  exports: [XpoGridBar],
})
export class XpoGridBarModule {}
